import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen bg-[#050510] text-white">
            <Navbar />
            <main className="pt-20">{children}</main>
            <Footer />
        </div>
    );
}
